import { useEffect, useRef } from 'react';

// Max interval allowed by `setInterval`
const MAX_INTERVAL_MS = 2147483647;

/**
 * This hook encapsulate the use of set interval in react components.
 * Source: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, Math.min(delay, MAX_INTERVAL_MS));
      return () => clearInterval(id);
    }
  }, [delay]);
}
